module.exports = "<div class=\"pageContent\">\n  <div style=\"min-height: 200px;\">\n      <p align=\"center\" class=\"right_image\"><img alt=\"\" src=\"assets/images/thankyou.png\" align=\"center\"></p>\n      <h2 align=\"center\" class=\"thankyou\">Thank you!!</h2>\n      <p align=\"center\" class=\"submission\">Your submission is received and we will contact you soon.</p>\n</div>"


//////////////////
// WEBPACK FOOTER
// D:/Projects/Veepal/Veepal.Com/Dev/src/app/contact-inquiry/contact-inquiry.component.html
// module id = ../../../../../src/app/contact-inquiry/contact-inquiry.component.html
// module chunks = main